// 📁 Imports

// 💾 Variables
const menu = document.querySelector("[data-menu]");
const menuOverlay = document.querySelector("[data-menu-overlay]");
const openMenuTrigger = document.querySelectorAll("[data-menu-trigger-open]");
const closeMenuTrigger = document.querySelectorAll("[data-menu-trigger-close]");
const openClass =
  "opacity-100 visible translate-x-0 transition ease-in-out duration-300 transform";

// 📐 Functions
const openMenu = () => {
  menu.removeAttribute("style");
  setTimeout(() => {
    menu.classList.add(...openClass.split(" "));
  }, 100);

  if (menuOverlay) {
    menuOverlay.classList.remove("hidden");
  }
};

const closeMenu = () => {
  menu.classList.remove(...openClass.split(" "));

  setTimeout(() => {
    menu.setAttribute("style", "display: none");
  }, 300);

  if (menuOverlay) {
    menuOverlay.classList.add("hidden");
  }
};

// 🖱️ Event listener
if (openMenuTrigger.length !== 0) {
  Array.from(openMenuTrigger).forEach((triggerEl) => {
    triggerEl.addEventListener("click", (e) => {
      openMenu();
    });
  });
}

// 🖱️ Event listener
if (closeMenuTrigger.length !== 0) {
  Array.from(closeMenuTrigger).forEach((triggerEl) => {
    triggerEl.addEventListener("click", (e) => {
      closeMenu();
    });
  });
}


export { openMenu, closeMenu };
